export default {
  msThText: 'ms-th-text',
  msThDate: 'ms-th-date',
  msThBoolean: 'ms-th-boolean',
  msThEnum: 'ms-th-enum',
  msThCombobox: 'ms-th-combobox',
  msThNumber: 'ms-th-number',
  msThState: 'ms-th-state',
  msThTime: 'ms-th-time',
};
